/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Commune
 */
export interface Commune {
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    nameWithType: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    pathWithType: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    parentCode: string;
}

/**
 * Check if a given object implements the Commune interface.
 */
export function instanceOfCommune(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "nameWithType" in value;
    isInstance = isInstance && "path" in value;
    isInstance = isInstance && "pathWithType" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "parentCode" in value;

    return isInstance;
}

export function CommuneFromJSON(json: any): Commune {
    return CommuneFromJSONTyped(json, false);
}

export function CommuneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Commune {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'slug': json['slug'],
        'nameWithType': json['nameWithType'],
        'path': json['path'],
        'pathWithType': json['pathWithType'],
        'code': json['code'],
        'parentCode': json['parentCode'],
    };
}

export function CommuneToJSON(value?: Commune | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'slug': value.slug,
        'nameWithType': value.nameWithType,
        'path': value.path,
        'pathWithType': value.pathWithType,
        'code': value.code,
        'parentCode': value.parentCode,
    };
}

